import { Operator } from "@medplum/core";
import { useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProjectId } from "../utils";
import { MemoizedSearchControl } from "./Search/SearchControl";
import { Box } from "@mantine/core";

export interface MemberTableProps {
  resourceType: any;
  fields: string[];
}

export function MemberTable(props: MemberTableProps): JSX.Element {
  const medplum = useMedplum();
  const projectId = getProjectId(medplum);
  const navigate = useNavigate();
  const [search, setSearch] = useState<any>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (props.resourceType === "Patient") {
      setSearch({
        resourceType: props?.resourceType,
        fields: props.fields,
        count: 100,
      });
    }
    else if (props.resourceType === "Practitioner") {
      setSearch({
        resourceType: "ProjectMembership",
        filters: [
          {
            code: "project",
            operator: Operator.EQUALS,
            value: "Project/" + projectId,
          },
          {
            code: "profile-type",
            operator: Operator.EQUALS,
            value: props.resourceType,
          },
        ],
        fields: props.fields,
        count: 100,
      });
    } else if (props.resourceType === "ClientApplication") { 
      setSearch({
        resourceType: "ClientApplication",
       
        fields: props.fields,
        count: 100,
      });
    }
  }, [props?.resourceType]);

  function handleClick(e: any) {
    if (props?.resourceType === "Patient") {
      navigate("/patient/details/" + e.resource.id);
    } else {
      navigate(`/client/details/ClientApplication/${e.resource.id}`);
    }
    // window.location.href = e.resource.profile.reference;
  }

  return (
    <>
      
        {/* <LoadingOverlay visible={visible} overlayBlur={2}/> */}
        <Box>
        {search && (
          <MemoizedSearchControl
            search={search}
            onClick={(e) => handleClick(e)}
            onChange={(e) => setSearch(e.definition)}
            hideFilters
            hideToolbar
            setVisible={setVisible}
          />
        )}
      </Box>
    </>
  );
}
